import isEqual from 'lodash.isequal';

const storeEquivalentValuesInASingleVariable = (val1, val2) => {
    if (isEqual(val1, val2))
        return val1;
    else
        throw Error(`${val1},${val2} are not same values`);
};

export { storeEquivalentValuesInASingleVariable };
//# sourceMappingURL=storeEquivalentValuesInASingleVariable.js.map
